// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3bIwh","header":"MergedInvoice_header__3a1wl"};